export default __webpack_public_path__ + "static/media/icon_linkedin.d9b4b30b.svg";